import { render, staticRenderFns } from "./TotalCost.vue?vue&type=template&id=51e2dff8&"
import script from "./TotalCost.vue?vue&type=script&lang=js&"
export * from "./TotalCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51e2dff8')) {
      api.createRecord('51e2dff8', component.options)
    } else {
      api.reload('51e2dff8', component.options)
    }
    module.hot.accept("./TotalCost.vue?vue&type=template&id=51e2dff8&", function () {
      api.rerender('51e2dff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/production/jobcard/jobcard-view/components/TotalCost.vue"
export default component.exports